import {
  VpButton,
  VpModal,
  VpModalBody,
  VpModalCloseButton,
  VpModalDialog,
  VpModalFooter,
  VpModalHeader,
} from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: (confirmed: boolean) => void
}

const ActionCompletionConfirmationModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation('common')
  return (
    <VpModal
      data-testid="action-completion-confirmation-modal"
      open={open}
      onOpen={() => {}}
      onClose={() => onClose(false)}
    >
      <VpModalDialog aria-label="Confirm Action Completion">
        <VpModalHeader>
          <h1>{t('pages.action-list.completion-confirmation-modal.title')}</h1>
          <VpModalCloseButton />
        </VpModalHeader>
        <VpModalBody className="px-8">
          {t('pages.action-list.completion-confirmation-modal.message')}
        </VpModalBody>
        <VpModalFooter>
          <VpButton
            data-testid="cancel-button"
            className="w-full"
            variant="secondary"
            shape="squared"
            onClick={() => onClose(false)}
          >
            {t('global.cancel')}
          </VpButton>
          <VpButton
            data-testid="confirmation-button"
            className="w-full"
            shape="squared"
            onClick={() => onClose(true)}
          >
            {t('global.confirm')}
          </VpButton>
        </VpModalFooter>
      </VpModalDialog>
    </VpModal>
  )
}

export default ActionCompletionConfirmationModal
